import { z } from 'zod';

export const getImpactAnswersDtoSchema_TeamMobility = z.array(
  z.object({
    id: z.number(),
    userId: z.string(),
    projectId: z.number(),
    sector: z.string(),
    transportationMode: z.string(),
    passengerCount: z.string().or(z.number()),
    travelDistance: z.string().or(z.number()),
    numberOfDays: z.string().or(z.number()),
    isExternal: z.boolean(),
    label: z.string().nullable(),
    source: z.string().nullable(),
    score: z.number().optional(),
    tags: z
      .object({
        values: z
          .array(z.object({ id: z.number(), name: z.string() }))
          .optional(),
      })
      .optional(),
  }),
);

export type QuestionTeamMobilityDto = {
  id: number;
  userId: string;
  projectId: number;
  sector: string;
  transportationMode: string;
  passengerCount: string | number;
  travelDistance: string | number;
  numberOfDays: string | number;
  isExternal: boolean;
  label: string | null;
  source?: string | null;
  score?: number;
  tags?: { values?: Array<{ id: number; name: string }> };
};
